import { FC } from 'react'
import { TextButton } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useSelfEnrollment } from '@/views/courses/CourseInfo/hooks/useSelfEnrollment'
import { ButtonContainer } from './ButtonContainer/ButtonContainer'

export const SelfEnrollButton: FC = () => {
  const { t } = useTranslation()

  const { isSelfEnrollmentLoading, createSelfEnrollment } = useSelfEnrollment()

  return (
    <ButtonContainer>
      <TextButton
        data-qa="add-to-my-courses-button"
        loading={isSelfEnrollmentLoading}
        disabled={isSelfEnrollmentLoading}
        onClick={createSelfEnrollment}
        variant="secondary"
        leftIcon="CourseBoldStroke"
        size="large"
      >
        {t('courseDetails.addToMyCourses')}
      </TextButton>
    </ButtonContainer>
  )
}
